/* PD Page tabs — vanilla tabs controller.
 * Looks up every [data-pd-page-tabs] container on the page and wires up
 * click + keyboard navigation between the [role="tab"] buttons in the
 * .pd-page-tabs__nav and the matching [role="tabpanel"] elements in the
 * .pd-page-tabs__panels. Keeps things hidden via the `hidden` attribute
 * so missing JS still leaves the first panel visible. */
(function () {
  function activateTab(tablist, targetTab) {
    var tabs = tablist.querySelectorAll('[role="tab"]');
    var panels = tablist.parentElement.querySelectorAll('[role="tabpanel"]');

    tabs.forEach(function (tab) {
      var isActive = tab === targetTab;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var controls = targetTab.getAttribute('aria-controls');
      if (panel.id === controls) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function initTabs(container) {
    var tablist = container.querySelector('[role="tablist"]');
    if (!tablist) return;
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    if (tabs.length === 0) return;

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        activateTab(tablist, tab);
        tab.focus();
      });

      tab.addEventListener('keydown', function (event) {
        var key = event.key;
        var nextIndex = -1;
        if (key === 'ArrowRight' || key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (key === 'Home') {
          nextIndex = 0;
        } else if (key === 'End') {
          nextIndex = tabs.length - 1;
        }
        if (nextIndex >= 0) {
          event.preventDefault();
          activateTab(tablist, tabs[nextIndex]);
          tabs[nextIndex].focus();
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-pd-page-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
